import { AxiosError } from 'axios';

import { OnResponseFulfilled, OnResponseRejected } from '@libs/axios/types';

/**
 * 서버에서 응답받은 에러메시지가 있다면 error 메시지를 대체하는 interceptor
 */
export const onFulfilled: OnResponseFulfilled = (response) => response;

export const onRejected: OnResponseRejected = (error: AxiosError) => {
  if (error.response && error.response.data && error.response.data.message) {
    Object.assign(error, {
      message: error.response.data.message,
    });
  }
  return Promise.reject(error);
};
